<div class="footer">
  <div class="footer-partnership">
    <h2 class="footer-title">{{ footerData?.partneshipTitle }}</h2>
    <div class="footer-partnership-logos">
      <img
        *ngFor="let logo of footerData?.partnershipLogos"
        [src]="logo.image"
        [alt]="logo.altText"
        class="partner-logo"
      />
    </div>
  </div>

  <div class="footer-main">
    <div class="footer-links">
      <h3 class="footer-section-title">
        {{ footerData?.navigationLinksTitle }}
      </h3>
      <ul>
        <li *ngFor="let link of footerData?.navigationLinks">
          <a
            [href]="link.url"
            [target]="link.openInNewTab ? '_blank' : '_self'"
          >
            {{ link.label }}
            <mat-icon *ngIf="link.openInNewTab">open_in_new</mat-icon>
          </a>
        </li>
      </ul>
    </div>

    <div class="footer-social-media">
      <h3 class="footer-section-title">
        {{ footerData?.socialMediaLinksTitle }}
      </h3>
      <ul>
        <li
          *ngFor="let social of footerData?.socialMediaLinks"
          class="social-media-item"
        >
          <a [href]="social.link" target="_blank" class="social-media-link">
            <img
              [src]="social.icon"
              [alt]="social.platformName + ' Logo'"
              class="social-icon"
            />
            <span>{{ social.platformName }}</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="footer-funders">
      <h3 class="footer-section-title">
        {{ footerData?.fundersAndSupportersTitle }}
      </h3>
      <div class="footer-section-subtitle">
        {{ footerData?.fundersAndSupportersSubTitle }}
      </div>
      <div class="funders-logos">
        <img
          *ngFor="let logo of footerData?.fundersSupportersLogos"
          [src]="logo.image"
          [alt]="logo.altText"
          class="funder-logo"
        />
      </div>
      <div class="funders-body">
        <rsc-asp-rich-text
          *ngIf="footerData?.fundersAndSupportersBody?.json"
          [content]="footerData?.fundersAndSupportersBody?.json"
        ></rsc-asp-rich-text>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="footer-copyright">
      <rsc-asp-rich-text
        *ngIf="footerData?.copyrightInformation?.json"
        [content]="footerData?.copyrightInformation?.json"
      ></rsc-asp-rich-text>
    </div>
    <div class="footer-logo">
      <img
        *ngIf="footerData?.bottomLogo"
        [src]="footerData?.bottomLogo?.image?.url"
        [alt]="footerData?.bottomLogo?.altText"
      />
    </div>
  </div>
</div>
